import { faCloudDownload, faTrashCan } from '@fortawesome/pro-light-svg-icons'
import { CustomerModelType } from '@teinor/erp/types/company/customer'
import TwinIcon from '../../../../../baseComponents/TwinIcon'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { displayDateTime } from '../../../../../utils/globals/date'

interface CustomerGDPRFileProps {
    data: CustomerModelType
    deleteFile: () => void
}

const CustomerGDPRFile: React.FC<CustomerGDPRFileProps> = ({ data, deleteFile }) => {
    return (
        <div className='flex items-center gap-20'>
            <div>
                <div className='mb-6'><span className='medium12'><TwinTrans transKey={'responsible'}>Responsable</TwinTrans></span>  <span className='light12'>| {displayDateTime(new Date())}</span></div>
                <a href={data.gdpr_file} className=' block text-green-21 mt-10 cursor-pointer' rel="noreferrer">
                    <TwinTrans transKey='downloadFile'>Descargar fichero</TwinTrans>
                    <TwinIcon className='ml-10 ' icon={faCloudDownload} />
                </a>
            </div>
            <TwinIcon className='ml-5 cursor-pointer' icon={faTrashCan} onClick={deleteFile} />
        </div>
    )
}

export default CustomerGDPRFile